// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"500c33de","164":"0e5d5089","899":"cc8cd8aa"}[chunkId] + ".chunk.css";
};